import { Checkbox } from '@mui/material';
import { useDispatch } from 'react-redux';
import { pink } from '@mui/material/colors';
import React, { useContext, useState } from 'react';
import { Button, Modal, Row } from 'react-bootstrap';
import { createNotification } from 'react-redux-notify';
import F2FPackages from '../Face2Face/components/F2FPackages';
import { SocketContext } from '../../helpers/contexts/face2face';

import {
  getErrorNotificationMessage,
  getSuccessNotificationMessage,
} from '../helper/NotificationMessage';
import {
  f2fSession_create_Failure,
  f2fSession_create_Success,
} from '../../store/actions/Face2FaceAction';
import PermissionModal from './F2FPermisionModal';
import { getUserId } from '../../helpers/storage/user';
import SessionService from '../../helpers/services/f2f/session';
import PostsPaginationLoader from '../Loader/PostsPaginationLoader';
import PermissionService from '../../helpers/services/f2f/permission';
import { useNavigate } from 'react-router-dom';
import { parseContentServiceError } from '../../helpers/services/f2f/error';
import SendMessageToPerformer from '../Face2Face/components/SendMessageToPerformer';

import CloseIcon from '../../images/icons/close_icon.svg?react';
import F2FLogo from '../../images_new/icon/face_logo.svg?react';
import RoundCheck from '../../images_new/icon/check-rounded.svg?react';
import { getF2FLogoComponent } from '../../utils/brandingLocalSvgs';
import { getSiteName } from '../../utils/brandingConfig';

import './styles/F2FModal.scss';

const F2FPackageSelectionModal = ({
  isOpen,
  toggle,
  face2facepackage_data,
  id,
  toggleOpenPerformerOfflineModal,
  userData,
}) => {
  const F2FBrandLogo = getF2FLogoComponent();
  const siteName = getSiteName();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [recieve, setReceive] = useState();
  const [showing, setShow] = useState(false);
  const [pack_type, setPck_type] = useState();
  const [packagid, setPackage_id] = useState();
  const [loading, setLoading] = useState(false);
  const [craeteSessionLoading, setCreateSessionLoading] = useState(false);
  const [isCallPermissionModalOpen, setIsCallPermissionModalOpen] = useState({
    isOpen: false,
    message: null,
  });
  const { setUserCallDeclien, hanleInitializeCall } = useContext(SocketContext);

  const handlePermissionModal = (message) => {
    setIsCallPermissionModalOpen({
      isOpen: true,
      message: message,
    });
  };

  const createSession = async () => {
    setLoading(true);
    setIsCallPermissionModalOpen({
      isOpen: false,
      message: null,
    });
    const checkPermission = await PermissionService.handlePermission(handlePermissionModal);
    if (checkPermission) {
      if (!packagid) {
        setLoading(false);
        dispatch(createNotification(getErrorNotificationMessage('Package is not selected')));
        return;
      }

      setUserCallDeclien(true);
      localStorage.removeItem('session_data');
      await handleCreateSession({
        caller_id: getUserId(),
        type: pack_type != undefined ? pack_type : '',
        receiver_id: recieve != undefined ? recieve.toString() : '',
        package_id: packagid != undefined ? packagid.toString() : ''
      });
    }

    setLoading(false);
  };

  const handleCloseModal = () => {
    setShow(false);
    setPackage_id(null);
    toggle();
  };

  const handleCallRequestFailed = () => {
    setShow(false);
    setPackage_id(null);
    toggleOpenPerformerOfflineModal();
  }

  const handleCreateSession = async (data) => {
    try {
      const response = await SessionService.createSession(data);
      if (response.success) {
        dispatch(f2fSession_create_Success(response));
        if (response.isMissedCall) {
          dispatch(
            createNotification(
              getErrorNotificationMessage('Performer is not able to get your request'),
            ),
          );
          handleCallRequestFailed()
        } else {
          hanleInitializeCall({ id: response.data.id });  }
        return;
      } else {
        dispatch(f2fSession_create_Failure(response));
        dispatch(createNotification(getErrorNotificationMessage(response.message)));
        return;
      }
    } catch (error) {
      dispatch(f2fSession_create_Failure(error));
      dispatch(
        createNotification(getErrorNotificationMessage(parseContentServiceError(error.response))),
      );
    }
  };

  return (
    <>
      <Modal
        className={`custom-modal f2f-package-selection-modal ${localStorage.getItem('isDark') === 'true' ? 'dark' : 'light'
          }`}
        size='md'
        centered
        show={isOpen}
        onHide={handleCloseModal}
        scrollable={true}
      >
        {craeteSessionLoading && <PostsPaginationLoader />}
        {!craeteSessionLoading && face2facepackage_data?.length === 0 && (
          <SendMessageToPerformer
            data={{
              receiver_id: id,
              performer: userData,
            }}
            onSuccess={handleCloseModal}
            messageText={`Let ${userData?.name || userData?.username} know you'd like to call!`}
            hideUsername={true}
          />
        )}
        {!craeteSessionLoading && face2facepackage_data?.length > 0 && (
          <div className='f2f-packages-selection-modal'>
            <div className='f2f-package-close-icon sticky-icon'>
              <CloseIcon
                className='f2f-package-icon'
                role={'button'}
                aria-label='close'
                onClick={handleCloseModal}
                width='24px'
                height='24px'
              />
            </div>
            <Modal.Header className='f2f-packages-selection-header pb-0'>
              <div className='sf-logo-container'>
                <F2FBrandLogo className='f2f-sf-logo' aria-label='brand logo' />
              </div>
            </Modal.Header>
            <Modal.Body className='p-22 pt-0 pb-0 overflow-hidden'>
              <div>
                <div className='f2f-logo-container mb-3'>
                  <div>
                    <F2FLogo className='f2f-logo' />
                  </div>
                </div>
                <div className='f2f-packages-selection-modal-middle'>
                  <Row className='f2f-packages-selection-detail'>
                    {face2facepackage_data?.map((packageDetail, index) => (
                      <F2FPackages
                        key={index}
                        packagid={packagid}
                        setReceive={setReceive}
                        setPck_type={setPck_type}
                        packageDetail={packageDetail}
                        setPackage_id={setPackage_id}
                      />
                    ))}
                  </Row>
                </div>
                {/* <div>
                  <p className='terms-line'>
                    <span onClick={() => setShow(!showing)}>
                      <Checkbox
                        checkedIcon={<RoundCheck width='20px' height='20px' fill='#f2006c' />}
                        sx={{
                          color: pink[800],
                          '&.Mui-checked': {
                            color: pink[600],
                          },
                        }}
                      />
                    </span>
                    I also accept {siteName}&apos;s Terms of service and privacy policy
                  </p>
                </div> */}
              </div>
            </Modal.Body>

            <Modal.Footer
              className='f2f-packages-selection-footer justify-content-center'
              style={{ position: 'sticky', bottom: '0', background: '#000' }}
            >
              <div>
                <p className='terms-line'>
                  <span onClick={() => setShow(!showing)}>
                    <Checkbox
                      checkedIcon={<RoundCheck width='20px' height='20px' fill='#f2006c' />}
                      sx={{
                        color: pink[800],
                        paddingBlock: { xs: "0", sm: "9px" },
                        '&.Mui-checked': {
                          color: pink[600],
                        },
                      }}
                    />
                  </span>
                  I also accept {siteName}&apos;s Terms of service and privacy policy
                </p>
              </div>
              <div className='f2f-packages-selection-modal-bottom w-100 mt-0'>
                <div className='d-flex justify-content-end'>
                  {/* <Button
                    className="f2f-package-request-shedule-btn" disabled={!showing} variant="default"
                  >
                    Request Shedule
                  </Button> */}
                  <Button
                    className='f2f-package-request-btn mt-0'
                    onClick={createSession}
                    disabled={!showing || loading}
                    variant='default'
                  >
                    Request Face2Face
                  </Button>
                </div>
              </div>
            </Modal.Footer>
          </div>
        )}
      </Modal>

      <PermissionModal
        isOpen={isCallPermissionModalOpen?.isOpen || false}
        setIsCallPermissionModalOpen={setIsCallPermissionModalOpen}
        message={isCallPermissionModalOpen?.message}
        handleTryAgain={createSession}
      />
    </>
  );
};

export default F2FPackageSelectionModal;
